import { createContext } from 'react';
import { NOOP } from '@testsigma/atoms';

interface UFTElementsContext {
  currentPopup: any;
  updateCurrentPopup: Function;
  isWindowsUFT: boolean;
  updateIsWindowsUFT: Function;
  isImporting: boolean;
  updateIsImporting: Function;
  currentElementFile: any;
  updateCurrentElementFile: Function;
  isUploading: boolean;
  updateIsUploading: Function;
  handleUpload: Function;
  uftCurrentImportItem: any;
  updateUFTCurrentImportItem: Function;
}

const uftElementsContext: UFTElementsContext = {
  currentPopup: null,
  isWindowsUFT: false,
  isImporting: false,
  currentElementFile: null,
  updateCurrentPopup: NOOP,
  updateIsImporting: NOOP,
  updateCurrentElementFile: NOOP,
  updateIsWindowsUFT: NOOP,
  isUploading: false,
  updateIsUploading: NOOP,
  handleUpload: NOOP,
  uftCurrentImportItem: null,
  updateUFTCurrentImportItem: NOOP,
};

const UFTElementsContext = createContext(uftElementsContext);
export { UFTElementsContext };
